export const isValidEmail = (email) => {
    const regex = new RegExp(/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/);
    return regex.test(email);
};
export const isValidUsername = (username) => {
    const regex = new RegExp(/\S{4}/);
    return regex.test(username);
};
export const isValidPassword = (password) => {
    const cognitoPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.\\[\]{}\\(\\)?\-“!@#%&/,><\\’:;|_~`])\S{8,99}$/;
    const regex = new RegExp(cognitoPasswordRegex);
    return regex.test(password);
};
export const isValidPhoneNumber = (phoneNumber) => {
    const regex = new RegExp(/^(00 ?|\+ ?)(\d ?)+$/);
    return regex.test(phoneNumber);
};
export const passwordReminder = 'Must contain at least 1 lowercase and 1 uppercase letter, 1 number, 1 symbol, and be more than 8 characters long';
